import styled from "styled-components"; 

export const ContainerChildren = styled.div`
    display: flex;
    flex: 1;
    height: calc(100vh - 75px); /* Resta la altura del HeaderbarHome */
    height: calc(100dvh - 75px); /* Para mobile web con barra de navegador */
    overflow: hidden;
`;